// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs';
import antdPlugin from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/customParseFormat';
import weekday from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/weekday';
import weekYear from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/weekYear';
import weekOfYear from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/weekOfYear';
import isMoment from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/isMoment';
import localeData from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/localeData';
import localizedFormat from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/localizedFormat';
import duration from '/data/jenkins/workspace/nodejs-paas-backendadmin-预演-chensg/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
